var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "submission-form" }, [
      _c("div", { staticClass: "submission-form-header" }, [
        _c("h3", [_vm._v(_vm._s(_vm.templateDoc.title))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "submission-form-body" }, [
        _vm.templateLoaded
          ? _c(
              "div",
              [
                _vm._l(_vm.templateDoc["templates"], function(template) {
                  return _c("div", [
                    template.mappings && template.mappings.children
                      ? _c(
                          "div",
                          [
                            _c("form-data-tree", {
                              attrs: {
                                templateId: template.id,
                                mappings: template.mappings.children,
                                dataBus: _vm.dataBus,
                                showErrors: _vm.showErrors,
                                formErrors: _vm.formErrors
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                }),
                _vm._v(" "),
                _vm.showErrors
                  ? _c("h5", { staticClass: "error-msg" }, [
                      _vm._v("Please fill all the required fields.")
                    ])
                  : _vm._e()
              ],
              2
            )
          : _c(
              "div",
              [
                _c(
                  "content-placeholders",
                  [
                    _c("content-placeholders-img", {
                      style: { height: "400px" }
                    })
                  ],
                  1
                )
              ],
              1
            )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submission-form-footer" },
        [
          _c(
            "b-button",
            {
              staticClass: "submit-button",
              attrs: { variant: "secondary" },
              on: { click: _vm.submitForm }
            },
            [_vm._v("Submit")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cc7c1ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cc7c1ae","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/submit/submitForm.vue
// module id = 1076
// module chunks = 2